import { render } from "./AddCommuneModal.vue?vue&type=template&id=7416aa02&ts=true"
import script from "./AddCommuneModal.vue?vue&type=script&lang=ts"
export * from "./AddCommuneModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__